import { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { Drawer, type DrawerProps, Typography } from '@didaskill/ui/design-system';
import { globalMessages } from '@didaskill/ui/intl';

import { welcomeMessages } from '../DiscoveryDrawers.messages';
import * as styles from '../DiscoveryDrawers.styles';
import { DiscoveryWelcomeDrawerIllustration } from './DiscoveryWelcomeDrawerIllustration';

type DiscoveryWelcomeDrawerProps = {
  discoveryDuration: number;
  onClickContinue: () => void;
} & DrawerProps;

const DiscoveryWelcomeDrawerBase = ({
  discoveryDuration,
  onClickContinue,
  ...props
}: DiscoveryWelcomeDrawerProps) => {
  return (
    <Drawer position={Drawer.POSITIONS.FULL_SCREEN} css={styles.drawer} {...props}>
      <div />

      <div css={styles.drawerContent}>
        <DiscoveryWelcomeDrawerIllustration />

        <Typography variant={Typography.VARIANTS.HEADING_3}>
          <FormattedMessage {...welcomeMessages.TITLE} />
        </Typography>

        <Typography variant={Typography.VARIANTS.BODY_LARGE_REGULAR}>
          <FormattedMessage
            {...welcomeMessages.DESCRIPTION}
            values={{
              duration: discoveryDuration,
              b: (chunks) => (
                <Typography variant={Typography.VARIANTS.BODY_LARGE_BOLD}>{chunks}</Typography>
              ),
            }}
          />
        </Typography>
      </div>

      <Drawer.Actions>
        <Drawer.Action onClick={onClickContinue} variant={Drawer.Action.VARIANTS.PRIMARY}>
          <FormattedMessage {...globalMessages.CONTINUE} />
        </Drawer.Action>
      </Drawer.Actions>
    </Drawer>
  );
};

DiscoveryWelcomeDrawerBase.displayName = 'DiscoveryWelcomeDrawer';

export const DiscoveryWelcomeDrawer = memo(DiscoveryWelcomeDrawerBase);
